<template>
  <RevContainer>
    <RevSkeleton class="mb-48" height="36px" shape="rectangle" width="50%" />
    <RevSkeleton class="mb-32" height="36px" shape="rectangle" width="100%" />
    <div class="grid grid-cols-2 gap-x-24 lg:gap-x-40">
      <div v-for="col in 2" :key="`skeleton-${col}`" class="space-y-48">
        <div class="space-y-16">
          <div class="aspect-square">
            <RevSkeleton shape="rectangle" width="100%" />
          </div>
          <RevSkeleton height="36px" shape="rectangle" width="100%" />
          <RevSkeleton height="16px" shape="rectangle" width="100%" />
          <RevSkeleton height="16px" shape="rectangle" width="100%" />
          <RevSkeleton height="48px" shape="rectangle" width="100%" />
        </div>

        <div
          v-for="row in 4"
          :key="`skeleton-line-${col}-${row}`"
          class="space-y-16"
        >
          <RevSkeleton height="16px" shape="rectangle" width="100%" />
          <RevSkeleton height="46px" shape="rectangle" width="100%" />
        </div>
      </div>
    </div>
  </RevContainer>
</template>

<script lang="ts" setup>
import { RevContainer } from '@ds/components/Container'
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
